import {toggleClassOnWidth} from "../jquery-functions-library";

export var fnAdjustNavTabs = function () {

    var element = $('#steps');
    var className = 'nav-tabs-justified';
    var width = 490;

    $(window).on('resize', function () {
        toggleClassOnWidth(element, className, width);
    });

    toggleClassOnWidth(element, className, width);
};

// export var fnFixNavTabToggle = function () {
//     $(".nav a").off('click').on("click", function () {
//         console.log($(this));
//         $(".nav").find(".active").removeClass("active");
//         $(this).addClass("active");
//     });
// }
